'use client';

import FormSelect from '@/components/form/FormSelect/FormSelect';
import { localeAtom } from '@/features/lottery/atoms/localAtom';
import { Locales, LocalesType } from '@/types';
import { useAtom } from 'jotai';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import styles from './LocaleSwitch.module.scss';

function LocaleSwitch({
  paramLocale,
}: {
  paramLocale: LocalesType;
}) {
  const router = useRouter();
  const [_, setLocale] = useAtom(localeAtom);
  const [isLoading, setIsLoading] = useState(false);
  const { getValues, control } = useForm({
    mode: 'onChange',
    defaultValues: {
      selectLocale: paramLocale,
    },
  });

  useEffect(() => {
    setLocale(paramLocale);
  }, []);

  // 言語切り替え
  const handleLanguageSwitching = (locale: LocalesType) => {
    if (isLoading) return;
    setIsLoading(true);
    setLocale(locale);

    const params = new URLSearchParams(location.search);
    params.set('lang', locale);
    const newQuery = params.toString();
    router.push(`?${newQuery}`, { scroll: false });
    setIsLoading(false);
  };

  const changeSelectLocale = async () => {
    handleLanguageSwitching(getValues('selectLocale') as LocalesType);
  };

  const locales = Object.keys(Locales) as LocalesType[];

  return (
    <div className={styles.listContainer}>
      <FormSelect
        label='言語 / Language'
        name='selectLocale'
        control={control}
        required
        outlined
        items={locales.map((locale) => ({
          value: locale,
          text: Locales[locale].text,
        }))}
        onChange={changeSelectLocale}
        disabled={isLoading}
      />
    </div>
  );
}

export default LocaleSwitch;
